import { makeAutoObservable } from 'mobx'
import { toastStore } from 'shared/ui'
import { logger } from 'shared/lib'
import { MessagesApi } from 'entities/Message'
import { BuyCreditsModalStore } from 'entities/Billing/ui/BuyCreditsModal'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { type ConversationMessagesStore } from 'widgets/ConversationMessages'

export class CallContentStore {
  private _buyCreditsModalStore: BuyCreditsModalStore

  constructor(
    private _conversationMessagesStore: ConversationMessagesStore,
    private _entities: IEntitiesStore
  ) {
    this._buyCreditsModalStore = new BuyCreditsModalStore(
      this._entities.subscriptionStore,
      this._entities.organizationStore,
      this._entities.billingStore
    )

    makeAutoObservable(this)
  }

  get entities() {
    return this._entities
  }

  get isOrganizationOutOfMessage(): boolean {
    const trialCredits = this.entities.organizationStore.trialCredits
    const accountCredits = this.entities.organizationStore.accountCredits
    const isTrial = this.entities.subscriptionStore.isTrial

    if (isTrial && trialCredits <= 0) {
      return true
    }

    if (!isTrial && accountCredits <= 0) {
      if (this.entities.billingStore.autorecharge?.is_active) return false
      return true
    }

    return false
  }

  checkOrganizationOutOfCredits = (): boolean => {
    const trialCredits = this.entities.organizationStore.trialCredits
    const accountCredits = this.entities.organizationStore.accountCredits
    const isTrial = this.entities.subscriptionStore.isTrial
    const can_manage_billing_settings = this._entities.userPermissionsStore.getItem(
      'can_manage_billing_settings'
    )

    if (isTrial && trialCredits <= 0) {
      toastStore.add({
        title: 'Your organization is out of message credits',
        type: 'error',
      })

      return true
    }

    if (!isTrial && accountCredits <= 0) {
      if (this.entities.billingStore.autorecharge?.is_active) return false
      if (!can_manage_billing_settings) {
        toastStore.add({
          title: 'Your organization is out of message credits',
          type: 'error',
        })

        return true
      }

      this._buyCreditsModalStore.openModal()

      return true
    }

    return false
  }

  retryTranscript = async (id: number) => {
    if (!this.checkOrganizationOutOfCredits()) {
      try {
        this._conversationMessagesStore.updateRecordTranscriptStatus(id, 'in_progress')
        this._conversationMessagesStore.updateTranscriptStatus(id, 'record')
        const { data } = await MessagesApi.manualMessagesByIdTranscript(id)

        this._conversationMessagesStore.updateTranscriptStatus(id, data.status)
        if (data.record) {
          this._conversationMessagesStore.updateRecordTranscriptStatus(
            id,
            data.record.transcript_status
          )
        }
      } catch (e) {
        logger.error(e)
        this._conversationMessagesStore.updateRecordTranscriptStatus(id, null)
        this._conversationMessagesStore.updateTranscriptStatus(id, '')
      }
    }
  }
}
